<template>
<span :class="status == true ? 'bgc-sgreenone c-greenfour' : 'bgc-sorangeone c-sorangefive'">
    {{ status == true ? 'COMPLETO' : status == 0 ? 'PENDENTE' : 'PENDENTE' }}
</span>
</template>

<script>
export default {
    props: {
        status: {
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
span {
    display: inline-flex;
    justify-content: space-between;
    padding: 4px 8px;
    border-radius: 26px;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
}
</style>